import { Stack, StackProps, styled } from '@mui/material';
import clsx from 'clsx';

import { drawerCssVars } from './cssVars';
import { tokens } from '../../theme/generated/tokens';
import { mergeSx } from '../../utils';

const Footer = styled(Stack)({
  width: '100%',
  flexShrink: 0,
  flexDirection: 'row',
  justifyContent: 'flex-end',
  gap: 16,
  backgroundColor: tokens.theme.bg.structural.surface,
  borderTop: `1px solid ${tokens.theme.border.structural.neutral}`,

  '.DS-Drawer-colorSecondary &': {
    backgroundColor: tokens.theme.bg.structural.surfaceInverse,
    borderTop: `1px solid ${tokens.theme.border.structural.inverse}`,
  },
});

export type DrawerFooterProps = StackProps & {
  testId?: string;
};

export const DrawerFooter = ({
  testId,
  className,
  sx,
  ...props
}: DrawerFooterProps) => {
  return (
    <Footer
      component="footer"
      {...props}
      className={clsx('DS-Drawer-Footer', className)}
      sx={mergeSx(
        {
          py: drawerCssVars.getters.verticalFooterPadding(),
          px: drawerCssVars.getters.horizontalPadding(),
        },
        sx
      )}
      data-testid={testId}
    />
  );
};
